import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AbilityContext } from '../../context/AbilityContext';
import { Announcement as TAnnouncement } from '../../types/announcements';
import NoDataFound from '../global-components/no-data-found';
import SideDrawer from '../side-drawer';
import Announcement from './announcement';
import AnnouncementDetail from './announcement-detail';
import './anouncements.scss';

type Props = {
  showLoader: boolean;
  viewAll?: boolean;
  announcements: TAnnouncement[];
  noDataFound: boolean;
};

const Announcements = ({
  showLoader,
  noDataFound,
  announcements,
  viewAll = false,
}: Props) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedAnnouncement, setSelectedAnnouncement] =
    useState<TAnnouncement>();
  const navigate = useNavigate();
  const ability = useContext(AbilityContext);

  const handleViewMoreClick = (selectedAnnouncement: TAnnouncement) => {
    setSelectedAnnouncement(selectedAnnouncement);
    setIsDrawerOpen(true);
  };

  const handleViewAll = () => {
    if (ability.can('read', 'Admin Announcements')) {
      navigate('/app/admin/announcements');
      return;
    }
    navigate('/app/announcements');
  };

  return (
    <>
      <div className={`ubbe-card ${viewAll && !noDataFound ? 'bbr-none' : ''}`}>
        <div className='ubbe-card-header d-flex justify-content-between'>
          <h5 className='ps-3 mb-0 GlobalBoxHead'>Announcements</h5>
          {!viewAll && (
            <h5
              className='pe-3 mb-0 GlobalBoxHead btn btn-link'
              onClick={handleViewAll}
            >
              View All
            </h5>
          )}
        </div>
        <div className='card-body p-3 h-auto'>
          <div className='d-flex flex-column gap-2'>
            {showLoader && (
              <div className='spinner-border' role='status'>
                <span className='visually-hidden'></span>
              </div>
            )}
            {announcements.map((item, index) => (
              <Announcement
                onViewMoreClick={handleViewMoreClick}
                key={index}
                announcement={item}
              />
            ))}
            {noDataFound && <NoDataFound />}
          </div>
        </div>
      </div>

      <SideDrawer
        title='Announcement Details'
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
      >
        <AnnouncementDetail announcement={selectedAnnouncement} />
      </SideDrawer>
    </>
  );
};

export default Announcements;
